import { Button, Tab, TabList, Tooltip } from '@fluentui/react-components';
import { PersonAdd16Regular } from '@fluentui/react-icons';
import type { RunCollabState } from '../useRunCollab';
import { UserAvatar } from './UserAvatar';

export type IssueTab = 'open' | 'fixed';

const MAX_AVATARS = 4;

/** One slim row: Open/Fixed counts on the left, who's online and the Share entry point on the right. */
export function CollabBar({
  openCount,
  fixedCount,
  tab,
  onTab,
  state,
  onShare,
}: {
  openCount: number;
  fixedCount: number;
  tab: IssueTab;
  onTab: (tab: IssueTab) => void;
  state: RunCollabState;
  onShare: () => void;
}) {
  const nameOf = (userId: string, fallback: string) => {
    const person = state.participants.find((p) => p.userId === userId);
    return person?.displayName || person?.email || fallback;
  };
  const shown = state.online.slice(0, MAX_AVATARS);
  const overflow = state.online.length - shown.length;
  const onlineNames = state.online.map((p) => nameOf(p.userId, p.name)).join(', ');

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8 }}>
      <TabList size="small" selectedValue={tab} onTabSelect={(_, data) => onTab(data.value as IssueTab)}>
        <Tab value="open">Open {openCount}</Tab>
        <Tab value="fixed">Fixed {fixedCount}</Tab>
      </TabList>
      {/* V1-HIDDEN: collaborator management (who's online + Share). Uncomment to restore.
      <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
        {shown.length > 0 && (
          <Tooltip content={`Here now: ${onlineNames}`} relationship="label">
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {shown.map((p, index) => (
                <UserAvatar
                  key={p.userId}
                  size={20}
                  name={nameOf(p.userId, p.name)}
                  color={state.colorOf(p.userId)}
                  online
                  style={{ marginLeft: index === 0 ? 0 : -6, boxShadow: '0 0 0 1px white', borderRadius: '50%' }}
                />
              ))}
              {overflow > 0 && <span style={{ fontSize: 11, color: '#666', marginLeft: 4 }}>+{overflow}</span>}
            </div>
          </Tooltip>
        )}
        <Tooltip content="Share this run" relationship="label">
          <Button appearance="subtle" size="small" icon={<PersonAdd16Regular />} onClick={onShare} />
        </Tooltip>
      </div>
      */}
    </div>
  );
}
